import routes from './../routes'
import vue from 'vue'
import {filterResponse, filterErrors} from './../client'

export const getWallet = () => {
    return vue.http.get(routes.wallet.wallet).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const postActiveWallet = () => {
    return vue.http.post(routes.wallet.activeWallet).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getServiceCharge = (amount) => {
    return vue.http.get(routes.wallet.serviceCharge + `amount=${amount}`).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const postWalletFund = (data) => {
    data.authorizationCode = Date.now() + '_' + data.client.id;
    data.channel= 'web';
    return vue.http.post(routes.wallet.walletFund,data).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getWalletVerify = (walletId) => {
    return vue.http.get(routes.wallet.walletVerify + walletId).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const getTransactionStatus = (transactionId) => {
    return vue.http.get(routes.wallet.transactionStatus + transactionId).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const postLogin = (phone, password) => {
    return vue.http.post(routes.user.login, {
        phonenumber: phone,
        pin: password
    }).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}